import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AddPaymentMethodComponent} from './add-payment-method.component';

const routes: Routes = [
  { path: 'manage-payment-methods', component: AddPaymentMethodComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaymentusRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/payment/paymentus/paymentus-routing.module.ts